"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedStockFile = exports.getSelectedFileInPanel = exports.getSelectedFolderInPanel = exports.getActivePanel = void 0;

var getActivePanel = function getActivePanel(state) {
  return state.panel.getIn(['present', 'activePanel']);
};

exports.getActivePanel = getActivePanel;

var getSelectedFolderInPanel = function getSelectedFolderInPanel(state) {
  return state.panel.getIn(['present', 'selectedFolder']);
};

exports.getSelectedFolderInPanel = getSelectedFolderInPanel;

var getSelectedFileInPanel = function getSelectedFileInPanel(state) {
  return state.panel.getIn(['present', 'selectedFile']);
};

exports.getSelectedFileInPanel = getSelectedFileInPanel;

var getSelectedStockFile = function getSelectedStockFile(state) {
  return state.panel.getIn(['present', 'selectedStockFile']);
};

exports.getSelectedStockFile = getSelectedStockFile;